// project import
import dashboard from './dashboard';
import pages from './page';
import vendor from './vendor';
import opexVendor from './opex-vendor';
import client from './client';
import subcontractor from './subcontractor';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, vendor, opexVendor, client, subcontractor]
};

export default menuItems;
